<template>
    <div class="box-container" v-loading="loading">
        <div style="width:100%;margin:0 auto;padding:15px 15px;overflow:auto">
            <!-- <el-form ref="dataForm" :rules="rules" :model="result" label-position="left">
                <el-form-item v-if="this.person_code.paramDisplay===1" label="工号" prop="personCode">
                    <span v-if="this.person_code.paramNece===1" style="color:red">*</span>
                    <el-input v-model="result.personCode" placeholder="请输入工号" />
                </el-form-item>
                <el-form-item label="姓名" prop="personName">
                    <span style="color:red">*</span>
                    <el-input v-model="result.personName" placeholder="请输入姓名" />
                </el-form-item>
                <el-form-item v-if="this.person_cert_no.paramDisplay===1" label="身份证号码" prop="certNo">
                    <span v-if="this.person_cert_no.paramNece===1" style="color:red">*</span>
                    <el-input v-model="result.certNo" placeholder="请输入身份证号码" />
                </el-form-item>
                <el-form-item label="手机号" prop="phoneNo">
                    <span style="color:red">*</span>
                    <el-input v-model="result.phoneNo" placeholder="请输入手机号" >
                        <el-button slot="append" @click="getVerification" :disabled="this.timeOut!=0 && this.timeOut!=60"><span v-if="this.timeOut==0 || this.timeOut==60">获取验证码</span><span v-if="this.timeOut!=0 && this.timeOut!=60">{{timeOut}}s后重新获取</span></el-button> 
                    </el-input>
                </el-form-item>
                <el-form-item label="验证码">
                    <span style="color:red">*</span>
                    <el-input v-model="verificationCode" placeholder="请输入验证码"/>
                </el-form-item>
            </el-form> -->
            <el-form ref="ruleForm" :model="value" :rules="rules" label-position="left" style="width:100%;margin-bottom:30px">
                <el-form-item label="旧密码" prop="oldPass" class="wx-from-item">
                    <el-input
                        v-model="value.oldPass"
                        name="passwordInput"
                        type="password"
                    />
                </el-form-item>
                <el-form-item label="新密码" prop="newPass" class="wx-from-item">
                    <el-input
                        v-model="value.newPass"
                        name="password1Input"
                        type="password"
                    />
                </el-form-item>
                <el-form-item label="重复密码" prop="password2" class="wx-from-item">
                    <el-input
                        v-model="value.password2"
                        name="password2Input"
                        type="password"
                    />
                </el-form-item>
            </el-form>

      <div slot="footer" class="dialog-footer"> 
        <el-button type="primary" style="width:100%" @click="validate()">提交</el-button>
      </div>
    </div>
    </div>
</template>

<script>

// import util from '@/commons/util.js';
import AES from '@/commons/AES.js'

export default {
    name: 'changePassword',
    data(){
        var validateIdPasswordOld = (rule, value, callback) => {
            if (value === null) {
                callback(new Error('请输入旧密码'))
            } else {
                callback()
            }
        }
        var validateIdPassword = (rule, value, callback) => {
            if (value === null) {
                callback(new Error('请输入新密码'))
            } else if (value === this.value.oldPass) {
                callback(new Error('新密码不能与旧密码相同'))
            } else {
                var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
                if (re.test(value)) {
                callback()
                } else {
                // this.$refs.dataForm.validateField('mainVisitorCertNo');
                callback(new Error('密码长度至少8位，包含至少1个数字、1个小写字母与1个大写字母'))
                }
            }
        }
        var validateIdPasswordAgain = (rule, value, callback) => {
            if (value === null) {
                callback(new Error('请再次输入密码'))
            } else {
                //
                if (value === this.value.newPass) {
                callback()
                } else {
                // this.$refs.dataForm.validateField('mainVisitorCertNo');
                callback(new Error('两次密码不一致'))
                }
            }
        }
        return {
            loading:false,
            openId:'',
            username: '',
            value: {
                oldPass: '',
                newPass: '',
                password2: ''
            },
            key: '',
            userInfo: [],
            rules: {
                oldPass: [
                { required: true, validator: validateIdPasswordOld, trigger: 'blur' }
                ],
                newPass: [
                { required: true, validator: validateIdPassword, trigger: 'blur' }
                ],
                password2: [
                { required: true, validator: validateIdPasswordAgain, trigger: 'blur' }
                ]

            }
        }
    },
    computed: {
        // loading: function() {
        //     // return this.$store.state.loading;
        // }
    },
    created(){
        this.openId=localStorage.getItem("openid");
        if(!this.openId){
            this.getOpenId()
        }
        else{
            this.getPersonBasicInfo(this.openId)
        }
        this.value = {
        oldPass: '',
        newPass: '',
        password2: ''
      }
      this.key = AES.generatekey()
      console.log(this.key)
    },
    methods: {

        //-------------------------------------------------------------------------
        //------------------------------初始化方法----------------------------------
        //-------------------------------------------------------------------------


        getOpenId(){
            this.openId=localStorage.getItem("openid");
            if(!this.openId){
                const code = this.GetUrlParame('code') // 截取code  
                if (!code) {
                    // var domine = window.location.href.split("#")[0]; // 微信会自动识别#    并且清除#后面的内容
                    //这里的axios是已封装过的
                    this.$axios({
                        url: '/wx/move/oauth',
                        method: 'get',
                        params:{callbackUrl:window.PRODUCTION_CONFIG.$globalUrl+'/empreg'}
                    })
                    .then(res => {
                        let url=res.data.url
                        window.location.href = url;
                    })
                    .catch(err => {
                        this.$message({ type: 'error', message: '获取code失败'+err });
                        window.location.href = window.PRODUCTION_CONFIG.$globalUrl+'/error'
                    })
                } 
                else {
                    // console.log(code);
                    this.$axios({
                        url: '/wx/move/publicInfo',
                        method: 'get',
                        params:{code:code}
                    })
                    .then(res => {
                    //    console.log(res);
                        if (res) { 
                            localStorage.setItem("openid", res.data);
                            this.openId=localStorage.getItem("openid");
                            // this.$message({ type: 'info', message: res.data });
                            this.getPersonBasicInfo(this.openId)
                        }
                        // window.location.replace('/#' + url);
                    })
                    .catch(err => {
                        this.$message({ type: 'error', message: '获取openid失败'+err });
                        window.location.href = window.PRODUCTION_CONFIG.$globalUrl+'/error'
                    })
                }
                // this.openId=localStorage.getItem("openid");
            }
            
        },
        GetUrlParame (parameName) {
            /// 获取地址栏指定参数的值
            /// <param name="parameName">参数名</param>
            // 获取url中跟在问号后面的部分
            var parames = window.location.search
            // 检测参数是否存在
            if (parames.indexOf(parameName) > -1) {
                var parameValue = ''
                parameValue = parames.substring(parames.indexOf(parameName), parames.length)
                // 检测后面是否还有参数
                    if (parameValue.indexOf('&') > -1) {
                        // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
                        parameValue = parameValue.substring(0, parameValue.indexOf('&'))
                        // 去掉参数名, 得到最终纯值字符串
                        parameValue = parameValue.replace(parameName + '=', '')
                        return parameValue
                    }
                return ''
            }
        },
        getPersonBasicInfo(openId){
            this.$axios({
                url: '/wx/move/per-basicinfo/get',
                method: 'get',
                params:{openId:openId}
            })
            .then(res => {
                // console.log(res.data.personUuid)
                    this.username=res.data.personCode                          
            })
            .catch(err => {
                this.$message({ type: 'error', message: '查询人员uuId失败'+err });
            })
        },
        
        //-------------------------------------------------------------------------
        //------------------------------增删改方法----------------------------------
        //-------------------------------------------------------------------------

        validate() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                this.onSave()
                } else {
                this.$message({ type: 'error', message: '请更正错误的输入项！' })
                return false
                }
            })
        },

        onSave() {
        //   const that = this
            this.loading = true
            this.value.userName = this.username
            const value1 = JSON.parse(JSON.stringify(this.value))
            value1.oldPass = AES.encrypt(value1.oldPass, this.key)
            value1.newPass = AES.encrypt(value1.newPass, this.key)
            value1.password2 = AES.encrypt(value1.password2, this.key)
            this.$axios({
                    url: '/wx/move/user-info/pass',
                    method: 'put',
                    data:value1
                })
                .then(res => {
                    
                    if(res.status==200){
                        // console.log(res.data.result[0])
                        if(res.data.result[0].code===0){
                            
                            this.loading = false;
                            // this.$message({ type: 'success', message: '保存员工信息成功'});
                            
                            this.$alert('修改密码成功,即将退出此页面！', '提示', {
                                confirmButtonText: '确定',
                                showClose:false,
                                customClass:'com-box',
                                callback: action => {
                                    // this.$message({
                                    //     type: 'info',
                                    //     message: `action: ${ action }`
                                    // });
                                    WeixinJSBridge.call('closeWindow');
                                }
                            });

                        }
                        else{
                            // console.log(res);
                            this.loading = false;
                            this.$message({ type: 'error', message: '修改密码失败:'+res.data.result[0].msg });
                        } 
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.$message({ type: 'error', message: '修改密码失败'}+err);
                })
        }

        //-------------------------------------------------------------------------
        //------------------------------控件change、转换等方法----------------------
        //-------------------------------------------------------------------------

        //-------------------------------------------------------------------------
        //------------------------------dialog相关方法----------------------
        //-------------------------------------------------------------------------


    }

}
</script>

<style>
.box-container {
    max-width: 480px;
    width: 100%;
    background-color: $bg;
    overflow: auto;
  }
@media{
  .com-box{
    width: 300px !important;
  }
 }

.wx-from-item{
    margin-bottom:5px;
 }
</style>